/*
 * The workspaces a person is offered, as the screens use them. Only onboarded workspaces are listed:
 * one that is offboarding or offboarded has left the product (Dawid, 2026-10-19, "offboarded should
 * get gone from UI in the product in general", docs/2026-10-19-hothawk-replacement-call.md), so no
 * screen draws a lifecycle state. A direct link to one finds no workspace, as a foreign one does.
 */

/** A workspace as the switcher lists it. */
export interface ListedWorkspace {
  readonly id: string;
  readonly name: string;
  /**
   * Whether this person reaches inbox v2 here, decided by the API from the same rule as the
   * `inbox` routes. Carried in the list the screens already load so the rail asks nothing more.
   */
  readonly inbox?: boolean | undefined;
}

/** Where an address naming no workspace lands: the remembered workspace if listed, else the first. */
export function landingWorkspace<T extends ListedWorkspace>(
  workspaces: readonly T[],
  remembered: string | null,
): T | null {
  return workspaces.find((workspace) => workspace.id === remembered) ?? workspaces[0] ?? null;
}
